import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { ProfilesController } from './profiles.controller';
import { ProfilesService } from './profiles.service';
import { Profiles } from './profiles.entity';
import { ProfileAdapter } from './dto/profiles.adapter';

@Module({
  imports: [
    TypeOrmModule.forFeature([Profiles]),
  ],
  controllers: [ProfilesController],
  providers: [ProfilesService, ProfileAdapter, ApplicationExceptionHandler],
  exports: [ProfilesService]
})
export class ProfilesModule {}
